import '../../Navigation/Styles/mobileNavigation.scss';

await import('Feature/Common/code/Scripts/Common/forEach');
await import(/* webpackChunkName: "parents" */ 'Feature/Common/code/Scripts/Common/parents');

window.am = window.am || {};

window.am.mobileNavigation = new function () {
    var that = this;
    var desktopWidth = 1024;

    this.init = function ()
    {
        if (document.querySelector('.nav-mobile') == null)
        {
            return;
        }

        var navButtonOpen = document.querySelector('.nav-mobile-open');
        var navButtonClose = document.querySelector('.nav-mobile-header-close');
        var parentMenuItems = document.querySelectorAll('.nav-mobile-level-item[data-has-children="true"] > a');
        var menuHeaderItems = document.querySelectorAll('.nav-mobile-header-level-item > a');
        navButtonOpen.addEventListener('click', that.onOpenClick);
        navButtonClose.addEventListener('click', that.onCloseClick);
        window.addEventListener('resize', that.onResize);

        parentMenuItems.forEach(function (node)
        {
            node.addEventListener('click', that.onMenuParentItemClick);
        });

        menuHeaderItems.forEach(function (node)
        {
            node.addEventListener('click', that.onMenuHeaderItemClick);
        });

        that.resetToActiveLevel();
        that.setAnchorsAccessibility();
    };

    /**
     * Show full width mobile menu
     */
    this.onOpenClick = function () {
        var navMobile = document.querySelector('.nav-mobile');
        var navMobileHeader = document.querySelector('.nav-mobile-header');
        var closeButton = document.querySelector('.nav-mobile-header-close');
        var body = document.querySelector('body');

        window.scrollTo(0, 0);
        navMobile.classList.add('nav-mobile--visible');
        navMobileHeader.classList.add('nav-mobile-header--visible');
        navMobile.style.top = navMobileHeader.getBoundingClientRect().height;
        body.style.overflow = 'hidden';
        closeButton.querySelector('button').classList.add('js-hiraku-offcanvas-btn-active');
        closeButton.querySelector("button").setAttribute("aria-label", "Menü schließen");
    };

    /**
     * Close full width mobile menu
     */
    this.onCloseClick = function () {
        var navMobile = document.querySelector('.nav-mobile');
        var navMobileHeader = document.querySelector('.nav-mobile-header');
        var closeButton = document.querySelector('.nav-mobile-header-close');
        var body = document.querySelector('body');

        navMobile.classList.remove('nav-mobile--visible');
        navMobileHeader.classList.remove('nav-mobile-header--visible');
        body.style.overflow = 'auto';
        closeButton.querySelector('button').classList.remove('js-hiraku-offcanvas-btn-active');
        closeButton.querySelector("button").setAttribute("aria-label", "Menü öffnen")

        if (body.classList.contains('nav-mobile-show')) {
            body.style.position = 'initial';
        }

        setTimeout(function () {
            that.resetToActiveLevel();
        },
            420);
    };

    /**
     * Click handler for menu item
     * @param {any} event
     */
    this.onMenuParentItemClick = function (event) {
        event.preventDefault();
        var menuElement = document.querySelector('.nav-mobile-level[data-id="' + this.parentElement.dataset.id + '"]');
        that.showMenuLevel(menuElement);
    };

    /**
     * Click handler for Header menu item 
     * @param {any} event
     */
    this.onMenuHeaderItemClick = function (event) {
        event.preventDefault();

        // Get correct target menu level, default is root
        var menuElement = document.querySelector('.nav-mobile-level[data-id="' + this.parentElement.dataset.id + '"]')
            || document.querySelector('.nav-mobile-level[data-id="00000000-0000-0000-0000-000000000000"]');

        // Pre remove visible modifier, for correct animation direction
        document.querySelectorAll('.nav-mobile-level--visible').forEach(function (currentElement) {
            currentElement.classList.remove('nav-mobile-level--visible');
        });

        // Pre remove visible modifier, for correct animation direction
        document.querySelectorAll('.nav-mobile-header-level--visible').forEach(function (currentElement) {
            currentElement.classList.remove('nav-mobile-header-level--visible');
        });

        that.showMenuLevel(menuElement);
    };

    /**
     * Hide navigation on desktop size
     */
    this.onResize = function () {
        var navMobile = document.querySelector('.nav-mobile');

        if (window.innerWidth >= desktopWidth && navMobile.classList.contains('nav-mobile--visible')) {
                that.onCloseClick();
        }

        that.setAnchorsAccessibility();
    };

    /**
     * Disables anchors accessibility for desktop and enables it on mobile
     */
    this.setAnchorsAccessibility = function () {
        var anchors = document.querySelectorAll('.nav-mobile-header a, .nav-mobile a');
        if (window.innerWidth >= desktopWidth) {
            anchors.forEach(function (element) {
                element.setAttribute('tabindex', '-1');
                element.setAttribute('aria-hidden', 'true');
            });
        } else {
            anchors.forEach(function (element) {
                element.removeAttribute('tabindex');
                element.removeAttribute('aria-hidden');
            });
        }
    };

    /**
     * Resets all levels to the active one or default the root level menu
     */
    this.resetToActiveLevel = function () {
        var rootElement = document.querySelector('.nav-mobile-level[data-id="00000000-0000-0000-0000-000000000000"]');
        var activeMenuItem = document.querySelector('.nav-mobile-level-item--active');

        // Remove all modifiers for initial state
        document.querySelectorAll('.nav-mobile-level--visible, .nav-mobile-level--hidden').forEach(function (currentElement) {
            currentElement.classList.remove('nav-mobile-level--visible');
            currentElement.classList.remove('nav-mobile-level--hidden');
        });
        document.querySelectorAll('.nav-mobile-header-level--visible, .nav-mobile-header-level--hidden').forEach(function (currentElement) {
            currentElement.classList.remove('nav-mobile-header-level--visible');
            currentElement.classList.remove('nav-mobile-header-level--hidden');
        });

        if (activeMenuItem) {
            // Pre hide all parents
            var parent = document.querySelector('.nav-mobile-level[data-id="' + activeMenuItem.dataset.parentId + '"]');
            rootElement.classList.add('nav-mobile-level--hidden');

            while (parent) {
                // Also reset header
                var parentHeader = document.querySelector('.nav-mobile-header-level[data-id="' + parent.dataset.id + '"]');
                if (parentHeader) {
                    parentHeader.classList.add('nav-mobile-header-level--hidden');
                }

                parent.classList.add('nav-mobile-level--hidden');
                parent = document.querySelector('.nav-mobile-level[data-id="' + parent.dataset.parentId + '"]');
            }

            // Actually reset to active menu item
            that.showMenuLevel(activeMenuItem.parentElement);
        } else {
            // Default is root menu
            rootElement.classList.add('nav-mobile-level--visible');
            that.showMenuLevel(rootElement);
        }
    };

    /**
     * Shows the specific menu level element
     * @param {any} menuElementToShow
     */
    this.showMenuLevel = function (menuElementToShow) {
        // Pre hide all current visible
        document.querySelectorAll('.nav-mobile-level--visible').forEach(function (currentElement) {
            currentElement.classList.add('nav-mobile-level--hidden');
        });

        // Append meta navigations
        that.appendMetaNavigations(menuElementToShow);

        // slide new menu level in
        menuElementToShow.scrollTop = 0;
        menuElementToShow.classList.remove('nav-mobile-level--hidden');
        menuElementToShow.classList.add('nav-mobile-level--visible');

        // set header menu level
        var headerElement = document.querySelector('.nav-mobile-header-level[data-id="' + menuElementToShow.dataset.id + '"]');
        that.showMenuHeaderLevel(headerElement);
    };

    /**
     * Shows the specific menu header level element
     * @param {any} headerElementToShow
     */
    this.showMenuHeaderLevel = function (headerElementToShow) {
        // Pre hide all current visible
        document.querySelectorAll('.nav-mobile-header-level--visible').forEach(function (currentElement) {
            currentElement.classList.add('nav-mobile-header-level--hidden');
        });

        // slide new header in
        headerElementToShow.classList.remove('nav-mobile-header-level--hidden');
        headerElementToShow.classList.add('nav-mobile-header-level--visible');

        // Show logo, if root menu is reached
        var headerContentElement = document.querySelector('.nav-mobile-header-content');

        if (headerElementToShow.dataset.id === "00000000-0000-0000-0000-000000000000") {
            headerContentElement.classList.remove('nav-mobile-header-content--visible');
        } else {
            headerContentElement.classList.add('nav-mobile-header-content--visible');
        }
    };

    this.appendMetaNavigations = function (menuElement) {
        if (menuElement.dataset.hasMetaNavigationItems === 'true') {
            return;
        }

        var itemTemplates = document.querySelectorAll('.nav-mobile-meta-template > .nav-mobile-meta > .nav-mobile-meta-item');
        itemTemplates.forEach(function (currentItemTemplate) {
            menuElement.appendChild(currentItemTemplate.cloneNode(true));
        });

        menuElement.dataset.hasMetaNavigationItems = true;

        // Need to remove the original html markup because of the doubled id
        // and the original markup is no longer used.
        that.removeOriginalAfterCloned();
    };

    this.removeOriginalAfterCloned = function ()
    {
        var mobileSwitchNavigation = document.querySelector('.nav-mobile-meta-template .nav-mobile-meta-right');
            if (mobileSwitchNavigation != null) {
                mobileSwitchNavigation.parentElement.remove();
            }
    };

    this.fireNavItemEvent = (eventName, params) => {
        const event = new CustomEvent("mobileNavigationNavItem", { detail: {
            event: eventName,
            params: params
        }});

        window.dispatchEvent(event);

        return false;
    };
}

window.am.mobileNavigation.init();